import { Directive, ElementRef, Renderer2 } from '@angular/core'
import { tap } from 'rxjs/operators'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Directive()
export class MbPaymentOptionsWrapperBase {

  cart$ = this.activeCartService.getActive().pipe(
    tap(cart => {
      if (cart?.totalItems === 0 || Object.keys(cart).length === 0) {
        this.renderer.removeClass(this.elemRef?.nativeElement, 'hide-submit-component')
      } else {
        this.renderer.addClass(this.elemRef?.nativeElement, 'hide-submit-component')
      }
    })
  )
  constructor (protected activeCartService: ActiveCartService,
               protected elemRef: ElementRef,
               protected renderer: Renderer2) {
  }
}
